import { render, staticRenderFns } from "./CheckupInfoCard.vue?vue&type=template&id=768a9a85"
import script from "./CheckupInfoCard.vue?vue&type=script&lang=ts"
export * from "./CheckupInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports